module.exports = __webpack_public_path__ + "static/media/user_leds.aa772688.jpg";